import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import { pluginPath } from '../../constants/leadinConfig';
import UIImage from '../UIComponents/UIImage';
export default function FormGutenbergPreview() {
    return (_jsx(Fragment, { children: _jsx(UIImage, { alt: "Create a new Hubspot Form", src: `${pluginPath}/public/assets/images/hubspot-form.png` }) }));
}
